<template>
  <div class="body_app_entity">
    <!-- 采用左右布局 -->
    <el-container class="ht100">
      <!-- 左侧侧边栏 -->
      <el-aside :style="subNavDynamicStyle">
        <div class="subNav_Title">
          <h3>实体管理</h3>
          <div class="subNav_switchbox">
            <el-switch v-model="switchValue"
                       active-color="#459ae9"
                       inactive-color="#e8eaf0"
                       active-value="true"
                       inactive-value="false"
                       @change="test">
            </el-switch>
            <div class="switchtext">智能辅助</div>
          </div>
        </div>
        <!-- 侧边导航栏选项 -->
        <el-menu background-color="#f7f8fa"
                 style="border-right: none;"
                 :default-active="$route.path"
                 router>
          <template v-for="(r)  in routeData">
            <div :key="r.path">
              <el-submenu v-if="r.children"
                          :index="r.path">
                <template slot="title">
                  <span>{{ $t(r.name) }}</span>
                </template>
                <el-menu-item :index="child.path"
                              v-for="(child)  in r.children"
                              :key="child.path">
                  {{ $t(child.name) }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item :index="r.path"
                            v-else>
                <span slot="title">{{ $t(r.name) }}</span>
              </el-menu-item>
            </div>
          </template>
        </el-menu>
        <div v-show="switchShow"
             class="switch-block">
          <ul class="clearfix">
            <li class="switch-item">
              <a class="switch-item-block"
                 href="">
                <div class="icon-block-bg">
                  <svg class="icon"
                       aria-hidden="true">
                    <use xlink:href="#iconApplicationicons-kehuxitong"></use>
                  </svg>
                </div>
                <p>在线坐席</p>
              </a>
            </li>
            <li class="switch-item">
              <a class="switch-item-block"
                 href="">
                <div class="icon-block-bg">
                  <svg class="icon"
                       aria-hidden="true">
                    <use xlink:href="#iconApplicationicons-jiankongxitong"></use>
                  </svg>
                </div>
                <p>监控系统</p>
              </a>
            </li>
            <li class="switch-item">
              <a class="switch-item-block"
                 href="">
                <div class="icon-block-bg">
                  <svg class="icon"
                       aria-hidden="true">
                    <use xlink:href="#iconApplicationicons-hujiaoxitong"></use>
                  </svg>
                </div>
                <p>呼叫系统</p>
              </a>
            </li>
            <li class="switch-item">
              <a class="switch-item-block"
                 href="">
                <div class="icon-block-bg">
                  <svg class="icon"
                       aria-hidden="true">
                    <use xlink:href="#iconApplicationicons-wenjuandiaocha"></use>
                  </svg>
                </div>
                <p>问卷调查</p>
              </a>
            </li>
            <li class="switch-item">
              <a class="switch-item-block"
                 href="">
                <div class="icon-block-bg">
                  <svg class="icon"
                       aria-hidden="true">
                    <use xlink:href="#iconApplicationicons-zhinengwaihu"></use>
                  </svg>
                </div>
                <p>智能外呼</p>
              </a>
            </li>
          </ul>
        </div>
      </el-aside>
      <!-- 导航栏收缩小按钮 -->
      <div id="iconSubShrink"
           class="system-icon-sub-shrink"
           style="cursor:pointer;"
           :style="iconDynamicStyle"
           @click="clickIconSubShrink()">
        <svg class="icon"
             aria-hidden="true"
             :style="iconRotateDynamicStyle">
          <use xlink:href="#iconretract-arrow" />
        </svg>
      </div>

      <!-- 右侧主体面板:通过动态路由加载 -->
      <el-main class="pst">
        <router-view></router-view>
      </el-main>
    </el-container>
    <MessageComponent />
    <MessageBoxComponent />
  </div>
</template>
<script>
import '@/assets/scss/entity/index.css'
import '@/assets/scss/ai/index.css'
import '@/assets/entityfont/iconfont.css'
import '@/assets/aifont/iconfont.css'
import MessageBoxComponent from './components/MessageBoxComponent'
import MessageComponent from './components/MessageComponent'
export default {
  components: {
    MessageBoxComponent,
    MessageComponent
  },
  data () {
    return {
      switchValue: false,
      switchShow: false,
      // 动态路由
      routeData: [
        {
          name: '系统实体页面',
          path: '/entity/system',
          component: () => import('@/views/entity/system')
        }, {
          name: '自定义实体管理',
          path: '/entity/custom',
          children: [
            {
              name: '实体标注',
              path: '/entity/custom/tag',
              component: () => import('@/views/entity/custom/tag')
            }, {
              name: '规则类实体',
              path: '/entity/custom/rule',
              component: () => import('@/views/entity/custom/rule')
            }
          ]
        }, {
          name: '集合实体',
          path: '/entity/gather',
          component: () => import('@/views/entity-extract/gather')
        }
      ],
      // 导航栏收缩涉及的动态样式
      shrinkSubNav: true,
      subNavDynamicStyle: {
        width: '180px',
        height: '100%',
        display: 'block',
        background: '#f7f8fa',
        'border-right': '1px solid #e1e3e6'
      },
      iconDynamicStyle: { left: '159px' },
      iconRotateDynamicStyle: { transform: 'rotate(0deg)' }
    }
  },
  mounted: function () {
    // 获取子菜单权限
    // this.routeData = this.$authUtis.getModuleMenu('/system')
    // this.routeData.filter(item => item.show !== 'false')
  },
  methods: {
    // 收缩或展开侧边导航栏
    clickIconSubShrink () {
      if (this.shrinkSubNav) {
        this.subNavDynamicStyle = { display: 'none' }
        this.iconDynamicStyle = { left: '0px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(180deg)' }
        this.shrinkSubNav = false
      } else {
        this.subNavDynamicStyle = {
          width: '180px',
          height: '100%',
          display: 'block',
          background: '#f7f8fa',
          'border-right': '1px solid #e1e3e6'
        }
        this.iconDynamicStyle = { left: '159px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(0deg)' }
        this.shrinkSubNav = true
      }
    },
    test: function (data) {
      if (data === 'true') {
        this.switchShow = true
      } else {
        this.switchShow = false
      }
    }
  }
}
</script>

<style scoped>
.subNav_Title {
  position: relative;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #e1e3e6;
  color: #222222;
  border-bottom: 1px solid #e1e3e6;
}
.system-icon-sub-shrink {
  position: absolute;
  left: 159px;
  top: 50%;
  z-index: 3;
  width: 20px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background-color: #fff;
  color: #8796a6;
  border-radius: 4px 0 4px 0;
  box-shadow: 0 0 10px #eaebee;
  transition: left 0.1s;
}
</style>
<style>
.body_app_entity {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC,
    Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei,
    sans-serif;
  font-size: 12px;
  color: #333333;
  line-height: 1.428571429;
  height: calc(100vh - 60px);
}
</style>
